import Divider from "@mui/material/Divider";
import PropTypes from "prop-types";
import React from "react";
import { format_ShortDOW_Date, getShiftTime } from "../util/dateTimeFormatter.js";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  cell: {
    width: "100%",
    height: "initial",
    lineHeight: "normal",
    textAlign: "left",
  },
  employee: {
    padding: "15px",
    paddingLeft: "0px",
  },
}));

const EmployeeShiftCell = (props) => {
  const classes = useStyles();

  const renderEmployeeShift = (emp) => {
    return format_ShortDOW_Date(emp.shiftStart) + " " + getShiftTime(emp.shiftStart) + "-" + getShiftTime(emp.shiftEnd);
  };

  return (
    <div className={classes.cell} data-testid="employee-shift-cell">
      {props.empTwoShift.shiftStart ? (
        <div className={classes.employee}>{renderEmployeeShift(props.empTwoShift)}</div>
      ) : (
        <div className={classes.employee}>N/A</div>
      )}
      <Divider />
      <div className={classes.employee}>{renderEmployeeShift(props.empOneShift)}</div>
    </div>
  );
};

EmployeeShiftCell.propTypes = {
  empOneShift: PropTypes.object.isRequired,
  empTwoShift: PropTypes.object.isRequired,
};

export default EmployeeShiftCell;
